module.exports = __webpack_public_path__ + "static/media/ticket-red-notification.71bcf658.svg";